/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import classNames from 'classnames';
import reactUpdate from 'immutability-helper';
import $ from 'jquery';
import React, {useEffect, useRef, useState} from 'react';

import SignedExtFileURLProxy from 'external-files/SignedExtFileURLProxy';
import {Image} from 'notebook/protocols/types/ImageType';
import notifications, {Response} from 'notifications';
import makeUseGlobalClientState from 'ui-library/hooks/global-client-state/makeUseGlobalClientState';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import DragDropUpload from 'util/DragDropUpload';
import * as net from 'util/Net';

interface Props {
  cid: string;
  image: Image;
  pasteHandler: () => void;
  updateHandler: (image: Image) => void;
  deleteHandler: () => void;
  mouseDownHandler: () => void;
  mouseOverHandler: () => void;
  locked: boolean;
  owningEntityApiId: string;
}

export const SUPPORTED_TYPES = ['image/jpeg', 'image/png', 'image/gif'];
const cachedTmpURL = makeUseGlobalClientState<string | null>(null);

export function uploadFile(file: string | Blob): JQueryDeferred<string | null> {
  const deferred = $.Deferred<string | null>();
  net
    .postFile({
      url: '/1/api/protocols/upload-image-request',
      file,
      progress(e) {
        if (e.lengthComputable) {
          deferred.notify(e.loaded! / e.total!);
        }
      },
    })
    .fail((res: Response) => deferred.reject(res))
    .done((url: string | null) => deferred.resolve(url));
  return deferred;
}

export default function ImageEditable({
  cid,
  image,
  pasteHandler,
  updateHandler,
  deleteHandler,
  mouseDownHandler,
  mouseOverHandler,
  locked,
  owningEntityApiId,
}: Props): JSX.Element {
  const [loading, setLoading] = useState<boolean | undefined>(undefined);
  const [tmpURL, setTmpURL] = cachedTmpURL.useGlobalClientState(cid);
  const [showDefault, setShowDefault] = useState<boolean | undefined>(undefined);
  const [completed, setCompleted] = useState<number | undefined>(0);
  const classes = classNames({
    'image-editable': true,
    loading,
    'no-image-uploaded': !image.url,
  });
  const uploadWrapper = useRef<HTMLDivElement>(null);
  const imageInput = useRef<HTMLInputElement>(null);
  const mainRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const manager = DragDropUpload.getManager(uploadWrapper.current!);
    const mainRefCurrent = mainRef.current;
    const uploadWrapperCurrent = uploadWrapper.current;
    manager.push(uploadWrapper.current!);
    $(mainRefCurrent!).on('filedrop', attachFile);

    return () => {
      $(mainRefCurrent!).off('filedrop', attachFile);
      const manager = DragDropUpload.getManager(uploadWrapperCurrent!);
      manager.pop(uploadWrapperCurrent!);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function attachFile(e: any, files: any): void {
    addFile(files[0]);
  }

  function fileChoose(e: any): void {
    imageInput.current?.click();
    e.preventDefault();
  }

  function resetState(): void {
    setShowDefault(true);
    setLoading(false);
    setTmpURL(null);
    setCompleted(0);
  }

  function loadHandler(e: any): void {
    setLoading(false);
    setTmpURL(null);
  }

  function errorHandler(e: any): void {
    resetState();
  }

  function addFile(file: File): void {
    if (file == null) {
      return;
    }
    if (!SUPPORTED_TYPES.includes(file.type)) {
      notifications.error('Only GIF, JPG, and PNG files are supported at this time.');
      return;
    }
    setTmpURL(window.URL.createObjectURL(file));
    setShowDefault(true);
    setCompleted(0);
    setLoading(true);
    uploadFile(file)
      .progress((progress: number) => {
        setCompleted(progress * 100);
      })
      .fail((res: Response) => {
        resetState();
        notifications.notifyError(res);
      })
      .done((url: string | null) => {
        setShowDefault(false);
        const newImage = reactUpdate(image, {$merge: {url: url ?? undefined}});
        updateHandler(newImage);
        setCompleted(0);
      });
  }

  function addFromChooser(e: any): void {
    addFile(e.target.files[0]);
  }

  return (
    <div className={classes} onMouseOver={mouseOverHandler} onMouseDown={mouseDownHandler} ref={mainRef}>
      <form className="add-image-form" aria-label={`Image upload ${cid}`}>
        <input
          ref={imageInput}
          type="file"
          className="image-input hidden"
          accept="image/*"
          aria-label="Image file"
          onChange={addFromChooser}
        />
        <div className="upload-wrapper multi-editable" ref={uploadWrapper}>
          {!locked ? (
            <a className="big-btn del-btn round-btn" onClick={deleteHandler}>
              {'\u00D7'}
            </a>
          ) : undefined}
          {tmpURL ? (
            <img src={tmpURL} />
          ) : image.url && image.key && !showDefault ? (
            <SignedExtFileURLProxy
              url={image.url}
              externalFileId={image.key}
              renderWithSignedURL={(signedURL: string) => {
                if (signedURL === undefined) {
                  return <p className="u-spacing-top faded text-center">Loading...</p>;
                } else if (signedURL == null) {
                  return <p className="u-spacing-top faded text-center">Error loading file</p>;
                }
                return <img src={signedURL} onError={errorHandler} onLoad={loadHandler} className="img" />;
              }}
              owningEntityApiId={owningEntityApiId}
            />
          ) : (
            <div className="glyphicon-wrapper">
              <BenchlingIcon icon="image" />
            </div>
          )}
          {!locked ? (
            <div className="instructions">
              <span>Drag and drop</span>
              <button className="button button--small button--primary" onClick={fileChoose} type="button">
                or choose a file
              </button>
            </div>
          ) : undefined}
          <div className="progress-bar" style={{width: `${completed}%`}} />
        </div>
      </form>
    </div>
  );
}
